var map = {
	"./img0.png": 106,
	"./img1.png": 107,
	"./img2.png": 108,
	"./img3.png": 109,
	"./img4.png": 110,
	"./img5.png": 111,
	"./img6.png": 112,
	"./img7.png": 113,
	"./img8.png": 114,
	"./img9.png": 115,
	"./img91.png": 116,
	"./img92.png": 117
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 105;